$('.filter-content-container .filter-header').on('click', function(e){
	var parentBox = $(this).closest('.filter-box');

	$(this).closest('.filter-content-container').find('.filter-box.active').not(parentBox).removeClass('active');
	parentBox.toggleClass('active');

	return false;
});

$(document).click(function(event) {
	if ($(event.target).closest('.filter-box').length) return;
	$('.filter-box').removeClass('active');
	event.stopPropagation();
});